import { Container, Content } from './styles';

interface LeagueParticipants {
  id: number;
  userId: number;
  ligaId: number;
  isAdmin: boolean;
  pontos: number;
  createdAt: string;
  username: string;
  foto: string;
}

interface CardProps {
  participant: LeagueParticipants;
}

export const Card: React.FC<CardProps> = ({ participant }: CardProps) => {
  return (
    <Container>
      <Content>
        <span>
          <img
            src={
              participant.foto
                ? participant.foto
                : 'https://www.pinclipart.com/picdir/middle/157-1578186_user-profile-default-image-png-clipart.png'
            }
            alt={`Foto de ${participant.username}`}
          />
        </span>

        <div>
          <span>
            <h1>{participant.username}</h1>
            <h2>{participant.pontos} Pontos</h2>
          </span>
        </div>
      </Content>
    </Container>
  );
};
